import { DatePicker } from "antd";
import React, { useCallback, useEffect, useState } from "react";
import { Moment, parseZone } from "moment";
import { IFilterProps } from "./Interfaces";

const DATE_FORMAT = "YYYY-MM-DD";

const Filter: React.FC<IFilterProps> = ({
  setSelectedKeys,
  confirm,
  clearFilters,
  selectedKeys,
}) => {
  const [value, setValue] = useState<Moment | null>(null);

  useEffect(() => {
    if (selectedKeys.length > 0) {
      setValue(parseZone(selectedKeys[0], DATE_FORMAT));
    }
  }, [selectedKeys]);

  const onInputChange = useCallback(
    (moment) => {
      if (moment === null) {
        setValue(null);
        if (clearFilters) {
          clearFilters();
        }
        return;
      }

      setSelectedKeys([moment.format(DATE_FORMAT)]);
      setValue(moment);
      confirm();
    },
    [clearFilters, confirm, setSelectedKeys]
  );

  return (
    <div className="table-filter">
      <DatePicker onChange={onInputChange} value={value} size="small" />
    </div>
  );
};

export default Filter;
